import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getDetails, getSelectedContributorCategory, getSelectedContributorValue } from "./selectors"
import { getSortOrder, getGroupSortOrder } from "helpers/compositeSecuritiesDetails"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzeCompositeConcentrationDetails,
    details: getDetails(state, props),
    selected: getSelectedContributorCategory(state, props),
    selectedValue: getSelectedContributorValue(state, props),
    enableBasketDrillDown: true,
    sortOrder: getSortOrder(state),
    groupOrder: getGroupSortOrder(state),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
